const REPORT_EDITABLE_FIELDS = [
  [
    { id: "facility_type", type: "text" },
    { id: "facility_name", type: "text" },
    { id: "part_name", type: "text" },
  ],
  [
    { id: "building_name", type: "text" },
    { id: "floor", type: "text" },
    { id: "location", type: "text" },
  ],
  [
    { id: "ambient_temp", type: "text" },
    { id: "equipment_used", type: "text" },
    { id: "serial_number", type: "text" },
  ],
];

/*
 * Ud1000EditModal 역할:
 * - UD1000 보고서에서 수정 가능한 메타데이터와 점검 결과를 모달 안에서 편집한다.
 * - 보고서 본문과 같은 필드 구조를 유지하면서 저장/취소 액션만 분리해 제공한다.
 */
export default function Ud1000EditModal({
  t,
  form,
  handleChange,
  handleFusionResultChange,
  toFusionCode,
  fileFusionCode,
  fusionLabels,
  setIsReadOnly,
  onSave,
  isSaving,
  hasChanges,
}) {
  return (
    <div
      className="reportEditModalOverlay"
      role="presentation"
      onClick={() => setIsReadOnly(false)}
    >
      <div
        className="reportEditModal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="ud-report-edit-title"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="reportEditModalHeader">
          <div className="titleBox">
            <h3 id="ud-report-edit-title">{t("editorBtnBox.editButton")}</h3>
            <p>{t("imageFileIndex.report.title")}</p>
          </div>

          <button
            type="button"
            className="iconBtn"
            onClick={() => setIsReadOnly(false)}
            aria-label={t("editorBtnBox.cancelButton")}
          >
            X
          </button>
        </div>

        <div className="reportEditModalBody">
          {REPORT_EDITABLE_FIELDS.map((row, rowIndex) => (
            <div className="reportEditGrid" key={`report-edit-row-${rowIndex}`}>
              {row.map((field) => (
                <label className="reportEditField" key={field.id}>
                  <span className="label">{getFieldLabel(field.id, t)}</span>
                  <input
                    id={field.id}
                    type={field.type}
                    value={form?.[field.id] ?? ""}
                    onChange={handleChange}
                  />
                </label>
              ))}
            </div>
          ))}

          <div className="reportEditGrid">
            <label className="reportEditField">
              <span className="label">
                {t("imageFileIndex.report.fusionResultMultiline")}
              </span>
              <select
                onChange={handleFusionResultChange}
                id="fusion_result"
                value={toFusionCode(
                  form?.fusion_result_code ?? form?.fusion_result,
                  fileFusionCode,
                )}
              >
                <option value={0}>{fusionLabels[0]}</option>
                <option value={1}>{fusionLabels[1]}</option>
                <option value={2}>{fusionLabels[2]}</option>
                <option value={3}>{fusionLabels[3]}</option>
              </select>
            </label>
          </div>

          <label className="reportEditField textareaField">
            <span className="label">
              {t("imageFileIndex.report.inspectionResult.title")}
            </span>
            <textarea
              className="inspection"
              onChange={handleChange}
              id="inspection_result"
              value={form?.inspection_result ?? ""}
            />
          </label>
        </div>

        <div className="reportEditModalFooter">
          <button
            type="button"
            className="ghostBtn"
            onClick={() => setIsReadOnly(false)}
            disabled={isSaving}
          >
            {t("editorBtnBox.cancelButton")}
          </button>
          <button
            type="button"
            className="primaryBtn"
            onClick={onSave}
            disabled={!hasChanges || isSaving}
          >
            {isSaving ? "Saving..." : t("editorBtnBox.saveButton")}
          </button>
        </div>
      </div>
    </div>
  );
}

// HELPER: 편집 필드 id를 보고서 다국어 라벨과 매핑한다.
function getFieldLabel(id, t) {
  const labelMap = {
    facility_type: t("imageFileIndex.report.facilityType"),
    facility_name: t("imageFileIndex.report.facilityName"),
    part_name: t("imageFileIndex.report.partName"),
    building_name: t("imageFileIndex.report.buildingName"),
    floor: t("imageFileIndex.report.floor"),
    location: t("imageFileIndex.report.location"),
    ambient_temp: t("imageFileIndex.report.ambientTemperature"),
    equipment_used: t("imageFileIndex.report.equipmentUsed"),
    serial_number: t("imageFileIndex.report.serialNumber"),
  };

  return labelMap[id] ?? id;
}
